import { render, staticRenderFns } from "./HorseComponent.vue?vue&type=template&id=5fb94a19&scoped=true"
import script from "./HorseComponent.vue?vue&type=script&lang=ts"
export * from "./HorseComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb94a19",
  null
  
)

export default component.exports